export const glossary = {
    title: 'Glossary',
    overview: 'Explains terms that appear in Intelligent Business Analytics and terms related to analysis.'
}
